import { UserOpeningApplication } from "@/modules/application/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const UserOpeningApplicationPage = ({ isEdit, isCopy }: IOperationPageProps) => (
  <UserOpeningApplication isEdit={isEdit} isCopy={isCopy}/>
);
